import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import DataService from '../../services/data.service';
import LoaderOverlay from '../common/loader.component';
import { useNavigate } from 'react-router-dom';
import Confirmation from '../common/confimation.component';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
const Categories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [row, setCurrentRow] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    getCategories();
  }, []);

  const getCategories = () => {
    setLoading(true);
    DataService.getCategories()
      .then((response) => {
        setCategories(response.data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleAddCategory = () => {
    navigate('/add-category');
  };

  const deleteData = (row) => {
    setCurrentRow(row);
    setModalShow(true);
  };

  const updateStatus = () => {
    if (!row) return;

    setLoading(true);
    DataService.deleteCategory({ id: row.id })
      .then((response) => {
        toast.success('Category Deleted Successfully.')
        getCategories();
        setLoading(false);
        setModalShow(false);
      })
      .catch((error) => {
        console.log(error)
        toast.error(error.response.data.error)
        setLoading(false);
        setModalShow(false);
      });
  };

  const columns = [
    {
      name: 'ID',
      selector: row => row.id,
      sortable: true,
      width: '280px',
    },
    {
      name: 'Category Name',
      selector: row => row.name,
      sortable: true,
    },
    {
  name: 'Actions',
  cell: row => (
    <div className="d-flex gap-2 align-items-center">
      <FontAwesomeIcon
        icon={faEdit}
        className="text-primary"
        style={{ cursor: 'pointer', fontSize: '14px' }}
        onClick={() => editData(row)}
      />
      <FontAwesomeIcon
        icon={faTrash}
        className="text-danger"
        style={{ cursor: 'pointer', fontSize: '14px' }}
        onClick={() => deleteData(row)}
      />
    </div>
  ),
  ignoreRowClick: true,
  allowOverflow: true,
  width: '280px',
}
  ];
  const editData = (data) => {
      navigate('/edit-category', { state: { data } });
  }

  return (
    <>
      <LoaderOverlay loading={loading} />
    
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4>Service Categories</h4>
          <button className="btn btn-success" onClick={handleAddCategory}>Add Category</button>
        </div>

        <DataTable
          columns={columns}
          data={categories}
          pagination
          highlightOnHover
          striped
          responsive
          noHeader
        />
   

      <Confirmation
        show={modalShow}
        onHide={() => setModalShow(false)}
        onSave={updateStatus}
        handleClose = {() => setModalShow(false)}

      />
    </>
  );
};

export default Categories;
